/*
  Fornece um mecanismo reativo simples para exibir e ocultar modais globais na aplicação,
  utilizando o sistema de reatividade do Vue 3 (ref).
*/

import { ref } from 'vue'

export const modalEvent = ref({
  show: false,
  title: '',
  message: '',
  redirectTo: null
})

export const showModal = (title, message, redirectTo = null) => {
  modalEvent.value = {
    show: true,
    title,
    message,
    redirectTo
  }
}

export const hideModal = () => {
  modalEvent.value.show = false
}


/*
  Fornece um mecanismo reativo simples para notificar a NavBar
  quando a foto de perfil do usuário é atualizada
*/

export const fotoPerfilEvent = ref({
  updated: false
})

export const notifyFotoAtualizada = () => {
  fotoPerfilEvent.value = { updated: true }
}


/*
  Fornece um mecanismo reativo simples para notificar ComunidadeView para atualizar
  a quantidade de membros e o botão para entrar logo depois que um convite é aceito
*/

export const conviteAceitoEvent = ref({ comunidadeId: null })

export const notifyConviteAceito = (comunidadeId) => {
  conviteAceitoEvent.value = { comunidadeId }
}